import React from 'react';
import PropTypes from 'prop-types';
import {
  FieldInputProps,
  FieldMetaProps,
} from '../../Constants/ReduxFormPropTypes';
import { createStateOptions } from '../../Helpers/StateSelectOptions';
import SelectList from '../SelectList';

export const usStatePropType = PropTypes.arrayOf(
  PropTypes.shape({
    name: PropTypes.string,
    code: PropTypes.string,
  }),
);

const StateField = ({ input, meta, usStates }) => (
  <div className="col-sm form-group">
    <label
      htmlFor={input.name}
      className={
        meta.touched && meta.error ? 'label form-error__label' : 'label'
      }
    >
      State
    </label>
    {meta.touched && meta.error && (
      <div className="form-error">{meta.error}</div>
    )}
    <SelectList
      options={createStateOptions(usStates)}
      input={input}
      searchable
      placeholder="State"
    />
  </div>
);

StateField.propTypes = {
  input: FieldInputProps.isRequired,
  meta: FieldMetaProps.isRequired,
  usStates: usStatePropType.isRequired,
};

export default StateField;
